import { render, staticRenderFns } from "./viviendas.vue?vue&type=template&id=e2e90248"
import script from "./viviendas.vue?vue&type=script&lang=js"
export * from "./viviendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports